(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;
      this.isAtTop = false;

      this.suppressScrollUntil = 0;
      this.toggleBtn = this.querySelector('header-menu-toggle');
      this.toggleBtn?.addEventListener('click', () => {
        this.suppressScrollUntil = performance.now() + 250;
        this.header.classList.toggle('shopify-section-header-menu-open');
      });

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.disconnectedCallback?.();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (performance.now() < this.suppressScrollUntil) {
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop <= 0) {
        this.header.classList.remove('shopify-section-header-sticky');
        document.body.classList.remove('shopify-body-section-header-sticky');
        this.isAtTop = true;
        this.currentScrollTop = scrollTop;
        return;
      }
      if (this.isAtTop && scrollTop > 10) {
        this.isAtTop = false;
      }
      if (this.isAtTop) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oriavi-view-on-wall"] && !Shopify.designMode) return;
  try {
    
(() => {
  const textTokens = [
    'live preview',
    'view in room',
    'view on wall',
    'view on your wall',
    'preview in room',
    'preview on wall',
    'see it in your room',
    'see it on your wall'
  ];

  let nativeTrigger = null;
  let observer = null;
  let galleryObserver = null;
  let scanQueued = false;
  let moveQueued = false;
  const mobileGalleryMql = window.matchMedia('(max-width: 749px)');

  const normalizedText = (value) => String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();

  const identityText = (element) => normalizedText([
    element.id,
    typeof element.className === 'string' ? element.className : '',
    element.getAttribute('href'),
    element.getAttribute('aria-label'),
    element.getAttribute('title'),
    element.getAttribute('data-testid')
  ].filter(Boolean).join(' '));

  const isSemanticControl = (element) => {
    const tag = element.tagName.toLowerCase();
    return tag === 'button' || tag === 'a' || element.getAttribute('role') === 'button';
  };

  const isEligibleNativeTrigger = (element) => {
    if (!(element instanceof HTMLElement)) return false;
    if (element.hidden || element.getAttribute('aria-hidden') === 'true') return false;

    const style = window.getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden') return false;

    const rect = element.getBoundingClientRect();
    return element.getClientRects().length > 0 && rect.width > 1 && rect.height > 1;
  };

  const scoreCandidate = (element) => {
    if (!(element instanceof HTMLElement)) return -1;
    if (element.classList.contains('oriavi-pictureit-native-trigger')) return -1;
    if (!isEligibleNativeTrigger(element)) return -1;

    const identity = identityText(element);
    const candidateText = normalizedText(element.textContent);
    let score = 0;
    let matchedAppSignal = false;

    if (identity.includes('picture-it') || identity.includes('pictureit') || identity.includes('picture_it')) {
      score += 45;
      matchedAppSignal = true;
    }
    if (identity.includes('live-preview') || identity.includes('live_preview')) {
      score += 35;
      matchedAppSignal = true;
    }
    if (identity.includes('app.pictureit.co') || identity.includes('pictureit.co')) {
      score += 60;
      matchedAppSignal = true;
    }

    if (candidateText.length <= 80) {
      if (textTokens.includes(candidateText)) {
        score += 55;
        matchedAppSignal = true;
      } else if (textTokens.some((token) => candidateText.includes(token))) {
        score += 30;
        matchedAppSignal = true;
      }
    }

    if (!matchedAppSignal) return -1;
    if (isSemanticControl(element)) score += 70;
    if (element.hasAttribute('onclick')) score += 15;
    if (window.getComputedStyle(element).cursor === 'pointer') score += 10;

    return score;
  };

  const findNativeTrigger = () => {
    const selector = [
      'button',
      'a',
      '[role="button"]',
      '[id*="picture-it" i]',
      '[class*="picture-it" i]',
      '[id*="pictureit" i]',
      '[class*="pictureit" i]',
      '[id*="live-preview" i]',
      '[class*="live-preview" i]'
    ].join(',');

    let best = null;
    let bestScore = 69;

    document.querySelectorAll(selector).forEach((element) => {
      const score = scoreCandidate(element);
      if (score > bestScore) {
        best = element;
        bestScore = score;
      }
    });

    return best;
  };

  const getGallery = () => document.querySelector('product-gallery[id^="GalleryViewer-"]') || document.querySelector('product-gallery');

  const getActiveMediaHost = () => {
    const gallery = getGallery();
    if (!gallery) return null;

    const activeItems = Array.from(gallery.querySelectorAll('.product__media-item.is-active'));
    const activeItem = activeItems.find((item) => {
      const style = window.getComputedStyle(item);
      return style.display !== 'none' && item.getClientRects().length > 0;
    }) || activeItems[0] || gallery.querySelector('.product__media-item');

    return activeItem?.querySelector('.media-wrapper') || activeItem || gallery;
  };

  const ensureOriaviContent = (element) => {
    if (element.querySelector('.oriavi-view-on-wall__content')) return;

    element.setAttribute('aria-label', 'View on your wall');
    element.innerHTML = `
      <span class="oriavi-view-on-wall__content">
        <svg class="oriavi-view-on-wall__icon" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
          <path d="M2.75 12s3.45-6 9.25-6 9.25 6 9.25 6-3.45 6-9.25 6S2.75 12 2.75 12Z" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"></path>
          <circle cx="12" cy="12" r="2.65" stroke="currentColor" stroke-width="1.7"></circle>
        </svg>
        <span>View on your wall</span>
      </span>
    `;
  };

  const getButtonHost = () => {
    if (mobileGalleryMql.matches) return getGallery();
    return getActiveMediaHost();
  };

  const moveNativeTrigger = () => {
    if (!nativeTrigger || !nativeTrigger.isConnected) return;

    const host = getButtonHost();
    if (!host) return;

    if (nativeTrigger.parentElement !== host) host.appendChild(nativeTrigger);
  };

  const activateNativeTrigger = (element) => {
    nativeTrigger = element;
    ensureOriaviContent(nativeTrigger);
    nativeTrigger.classList.add('oriavi-pictureit-native-trigger');
    nativeTrigger.setAttribute('data-oriavi-pictureit-native', 'true');
    moveNativeTrigger();
    document.documentElement.classList.add('oriavi-pictureit-ready');
  };

  const scan = () => {
    if (nativeTrigger?.isConnected) {
      moveNativeTrigger();
      return true;
    }

    const found = findNativeTrigger();
    if (!found) return false;

    activateNativeTrigger(found);
    return true;
  };

  const queueScan = () => {
    if (nativeTrigger && !nativeTrigger.isConnected) {
      nativeTrigger = null;
      document.documentElement.classList.remove('oriavi-pictureit-ready');
    }

    if (scanQueued) return;
    scanQueued = true;
    window.requestAnimationFrame(() => {
      scanQueued = false;
      scan();
    });
  };

  const start = () => {
    const gallery = getGallery();
    if (!gallery) return;

    observer = new MutationObserver(queueScan);
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'aria-label', 'hidden']
    });

    galleryObserver = new MutationObserver(() => {
      if (moveQueued) return;
      moveQueued = true;
      window.requestAnimationFrame(() => {
        moveQueued = false;
        moveNativeTrigger();
      });
    });

    galleryObserver.observe(gallery, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden']
    });

    mobileGalleryMql.addEventListener('change', moveNativeTrigger);

    document.addEventListener('variant:change', () => {
      if (!nativeTrigger || !nativeTrigger.isConnected) {
        nativeTrigger = null;
        document.documentElement.classList.remove('oriavi-pictureit-ready');
      }
      queueScan();
    });

    scan();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

  } catch(e) { console.error(e); }
})();
})();
